import {Component} from 'react'
import PropTypes from 'prop-types'

import {generate} from '../../../../routes.js'
import conf from '../../../../conf.js'
import PurchaserSearchCard from '../../../../components/SearchCard/Purchaser/PurchaserSearchCard.jsx'
import PurchaserSearchListItem from '../../../../components/Purchaser/SearchListItem/PurchaserSearchListItem.jsx'
import SearchResults from '../../../Search/Components/SearchResults.jsx'

export default class PurchaserSearchResultsContainer extends Component {
  static propTypes = {
    currentUser: PropTypes.object.isRequired,
    flattenSearchObject: PropTypes.func.isRequired,
    isAdmin: PropTypes.bool.isRequired,
    loading: PropTypes.bool,
    search: PropTypes.func.isRequired,
    searchQuery: PropTypes.object.isRequired,
    searchRouteName: PropTypes.string.isRequired,
    searchTarget: PropTypes.string.isRequired,
  }

  static defaultProps = {
    loading: true,
  }

  static filters = {
    orders: [
      {
        name: 'created_sort',
        label: 'Inscription',
        tooltip: 'Tri sur la date d\'inscription',
        mustBeAdmin: true,
      }
    ],
    adminOnlyRequirements: false,
    requirementChoices: [
      {text: 'Défaut'},
      {value: 1, text: 'ID (Sans le #)'},
      {value: 2, text: 'Nom / Prénom'},
      {value: 3, text: 'Email'},
      {value: 4, text: 'Téléphone'},
    ]
  }

  generateLink = (offer, offset) => generate({
    name: 'purchasers.search.viewer.views',
    parameters: {
      offset,
      page: this.props.searchQuery.page
    },
    search: this.props.flattenSearchObject(this.props.searchQuery)
  })

  renderPurchasers = (purchasers) => {
    const scores = this.props?.searchQuery.scores?.length ? this.props.searchQuery.scores : []
    const searchLimit = parseInt(this.props?.searchQuery.limit ?? conf.search.limits.cards, 10)
    const Component = searchLimit === conf.search.limits.cards ? PurchaserSearchCard : PurchaserSearchListItem
    const purchasersItems = purchasers.map((purchaser, i) =>
      <Component
        offset={i}
        user={purchaser}
        generateLink={this.generateLink}
        key={purchaser.id}
        score={scores[purchaser.id] ? scores[purchaser.id] : false}
      />
    )

    if (searchLimit === conf.search.limits.cards) {
      return <div className="row">{purchasersItems}</div>
    }

    return <ul className="p-0">{purchasersItems}</ul>
  }

  render() {
    return (
      <SearchResults
        canToggleView={true}
        filters={PurchaserSearchResultsContainer.filters}
        flattenSearchObject={this.props.flattenSearchObject}
        isAdmin={this.props.isAdmin}
        loading={this.props.loading}
        search={this.props.search}
        renderResults={this.renderPurchasers}
        searchQuery={this.props.searchQuery}
        searchRouteName={this.props.searchRouteName}
        topologies={[]}
        target={this.props.searchTarget}
      />
    )
  }
}